<div class="flex bg-background h-full gap-2">
  <app-sidebar class="w-72 block"></app-sidebar>
  <div cdkScrollable class="flex-grow overflow-x-auto">
    <router-outlet></router-outlet>
  </div>
  <app-notification-center-panel></app-notification-center-panel>
</div>
